"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
const account_habit_1 = require("./account-habit");
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
const image_object_1 = __importDefault(require("./image-object"));
const utils_1 = require("./utils");
class Container extends base_1.default {
    constructor(data = {
        id: undefined,
        title: undefined,
        sub_title: undefined,
        friendly_name: undefined,
        time_required: undefined,
        icon: undefined,
        segments: [],
    }) {
        var _a;
        super(data);
        this.id = (0, defaults_1.defaultString)(data.id);
        this.title = (0, defaults_1.defaultString)(data.title);
        this.sub_title = (0, defaults_1.defaultString)(data.sub_title);
        this.friendly_name = (0, defaults_1.defaultString)(data.friendly_name);
        this.time_required = (0, defaults_1.defaultString)(data.time_required);
        this.icon = new image_object_1.default((0, defaults_1.defaultObject)(data.icon));
        this.is_milestone = (0, defaults_1.defaultBoolean)(data.is_milestone);
        this.segments = (0, defaults_1.defaultArray)((_a = data.segments) === null || _a === void 0 ? void 0 : _a.map((seg) => new _1.Segment(seg)));
    }
    get subTitle() {
        return this.sub_title;
    }
    get timeRequired() {
        return (0, utils_1.maybePluralize)(parseInt(this.time_required, 10), 'min');
    }
    getStatus(accountSegments, accountHabit) {
        if (accountHabit && accountHabit.unlockedManually) {
            return account_habit_1.HabitStates.COMPLETE;
        }
        const completed = this.segments.every((segment) => { var _a; return ((_a = accountSegments[segment.id]) === null || _a === void 0 ? void 0 : _a.status) === account_habit_1.HabitStates.COMPLETE; });
        if (completed)
            return account_habit_1.HabitStates.COMPLETE;
        const active = this.segments.some((segment) => { var _a; return ((_a = accountSegments[segment.id]) === null || _a === void 0 ? void 0 : _a.status) === account_habit_1.HabitStates.ACTIVE; });
        if (active)
            return account_habit_1.HabitStates.ACTIVE;
        const waiting = this.segments.some((segment) => { var _a; return ((_a = accountSegments[segment.id]) === null || _a === void 0 ? void 0 : _a.status) === account_habit_1.HabitStates.WAITING; });
        if (waiting)
            return account_habit_1.HabitStates.WAITING;
        return account_habit_1.HabitStates.LOCKED;
    }
    getActiveSegment(accountSegments) {
        return this.segments.find((s) => { var _a; return ((_a = accountSegments[s.id]) === null || _a === void 0 ? void 0 : _a.status) === account_habit_1.HabitStates.ACTIVE; });
    }
    getActiveOrCompleteSegment(accountSegments) {
        return this.segments.find((s) => {
            var _a, _b;
            return ((_a = accountSegments[s.id]) === null || _a === void 0 ? void 0 : _a.status) === account_habit_1.HabitStates.ACTIVE
                || ((_b = accountSegments[s.id]) === null || _b === void 0 ? void 0 : _b.status) === account_habit_1.HabitStates.COMPLETE;
        });
    }
    get isMilestone() {
        return this.is_milestone;
    }
}
exports.default = Container;
